import { useTranslation } from 'react-i18next'

import { StatusPill } from '@/components/ui/StatusPill'
import type { PricingState } from '@/types/domain'

/* The pricing state as a pill (S-2a): «Расчёт не запрошен», «Ждёт расчёта»,
 * «Расчёт готов» — the quote's «Расчёт» card and the board's draft cards say
 * it with this one component, so the two cannot word or colour it apart.
 *
 * The tones follow the brand rules rather than inventing a fourth meaning:
 * waiting on Pricing is IN PROGRESS, which is what Gateway Blue is for; a ready
 * price is the success tone; nobody asked is neutral. The label always rides
 * with the tone and the pill's dot, so colour never carries the state alone. */

const TONES = {
  none: 'neutral',
  requested: 'brand',
  ready: 'positive',
} as const satisfies Record<PricingState, 'neutral' | 'brand' | 'positive'>

export function QuotePricingPill({ state }: { state: PricingState }) {
  const { t } = useTranslation()
  return <StatusPill tone={TONES[state]}>{t(`quotes.pricingState.states.${state}`)}</StatusPill>
}
